import React, { useEffect, useState } from "react";
import moment from "moment-timezone";

const Timer = ({ lastLoaded }: { lastLoaded: Number }) => {
  const [currentTime, setCurrentTime] = useState<Number>(Date.now());

  useEffect(() => {
    const int = setInterval(() => setCurrentTime(Date.now()), 5 * 1000);
    return () => clearInterval(int);
  }, []);

  return <span>{moment(lastLoaded as any).from(currentTime as any)}</span>;
};

export default Timer;
